import React from "react";

import {useAppDispatch, useAppSelector} from "src/store/store";

import {setStepIncrease} from "src/store/features/licenseSlice";
import {DocumentationLink} from "../../ui/DocumentationLink";

const LicenseFile = () => {
    const dispatch = useAppDispatch()
    const stepIncrease = useAppSelector((state) => state.license.stepIncrease)
    const onStepsNext = () => {
        dispatch(setStepIncrease(stepIncrease + 1))
    }

    return (
        <section className="py-14 max-w-screen-xl mx-auto">
            <div
                className="w-full p-4 text-center bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-900 dark:border-gray-800 dark:shadow-gray-300 transition-colors duration-300">
                <div className="relative z-10 max-w-xl mx-auto sm:text-center">
                    <div className="space-y-3">
                        <h3 className="text-3xl font-bold">
                            Dosya Seçimi
                        </h3>
                        <p>
                            İndirilen dosyayı <b>Genel İşlemler &gt; Otomasyon Seçenekleri &gt; Lisans
                            Aktifleştirme </b> butonuna basarak açılan ekranda dosyayı seçiniz
                        </p>
                    </div>
                    <button
                        onClick={onStepsNext}
                        className={`w-1/2 px-4 py-2 mt-5 items-center justify-center inline-flex cursor-pointer bg-blue-600 hover:bg-blue-800 text-white rounded-lg`}>
                        <div className="-mt-1 font-sans text-sm font-medium">
                            İleri
                        </div>
                    </button>
                </div>
                <DocumentationLink/>
            </div>


        </section>
    )
}

export default LicenseFile